type Listener = () => void;
const listeners = new Set<Listener>();

export const onPaymentsEvent = (fn: Listener) => {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
};

export const emitPaymentsChanged = () => listeners.forEach((fn) => fn());
